export default "__VITE_ASSET__ChdBf0F8__"